import { PropsWithChildren } from 'react';

import { PostHogProvider } from 'posthog-js/react';

const posthogOptions = {
  api_host: ENV.PUBLIC_POSTHOG_HOST,
};

export const AppPosthogProvider = (props: PropsWithChildren) => {
  return (
    <PostHogProvider apiKey={ENV.PUBLIC_POSTHOG_KEY} options={posthogOptions}>
      {props.children}
    </PostHogProvider>
  );
};
